import * as React from "react";
const IconWheelchair = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M40.2 52.3c-3.1 3.5-7.6 5.4-12.3 5.4-9.2 0-16.7-7.5-16.7-16.7 0-5.4 2.5-10.3 6.8-13.4 1-.7 1.2-2.1.5-3.1s-2.1-1.2-3.1-.5C10 27.9 6.8 34.3 6.8 41c0 11.7 9.5 21.2 21.2 21.2 6 0 11.7-2.5 15.7-6.9.8-.9.8-2.3-.2-3.2-1-.8-2.5-.7-3.3.2" />
    <path d="m54.9 48.9-4 .3L49.6 35c-.1-1.5-1.3-2.7-2.9-2.7H26.8l-.5-8.2h13.3c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2H26.1l-.2-2.9c3.6-.6 6.4-3.7 6.4-7.4 0-4.1-3.4-7.5-7.5-7.5s-7.5 3.4-7.5 7.5c0 2.9 1.7 5.5 4.1 6.7l1.1 18.1c0 1.5 1.3 2.7 2.9 2.7h20l1.2 14.4v.3c.3 1.4 1.5 2.4 2.9 2.4h.1l5.7-.5c1.2-.1 2.2-1.2 2.1-2.4-.2-1.4-1.3-2.3-2.5-2.2M24.7 6.2c1.7 0 3 1.4 3 3s-1.4 3-3 3-3-1.4-3-3 1.4-3 3-3" />
  </svg>
);
export default IconWheelchair;
